/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Script } from './Script.js';
import {
    ScriptFromJSON,
    ScriptFromJSONTyped,
    ScriptToJSON,
} from './Script.js';

/**
 * 
 * @export
 * @interface ScriptsResponse
 */
export interface ScriptsResponse {
    /**
     * 
     * @type {Array<Script>}
     * @memberof ScriptsResponse
     */
    data?: Array<Script>;
    /**
     * 
     * @type {number}
     * @memberof ScriptsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScriptsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ScriptsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ScriptsResponse interface.
 */
export function instanceOfScriptsResponse(value: object): boolean {
    return true;
}

export function ScriptsResponseFromJSON(json: any): ScriptsResponse {
    return ScriptsResponseFromJSONTyped(json, false);
}

export function ScriptsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScriptsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScriptFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ScriptsResponseToJSON(value?: ScriptsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScriptToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

